/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Count/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Count({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Payors/Payor/Count"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtColorsGreen700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700'
        })
let payorItemIndexValueData = fromData.useDataValue({ viewPath,
context: 'payor_item',
path: 'index',
})
let constantData = 1
let aggregateData = fromAggregate.add(payorItemIndexValueData, constantData)
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
  return (<React.Fragment
>
<div
  data-testid="Count.Horizontal"
  data-view-path={viewPath}
 style={{'--h-1-4HFG1': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--w-2-4HFG1': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM,'--bblr-3-4HFG1': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--bbrr-4-4HFG1': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--btlr-5-4HFG1': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--btrr-6-4HFG1': typeof dtSpaceXxxs === 'number' ? `${dtSpaceXxxs}px` : dtSpaceXxxs,'--bc-7-4HFG1': dtColorsGreen700}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="payor_item.index"
 data={1}
 aggregate="/Data/aggregate.js add"
 text={aggregateData}
 color={dtColorsNeutral100}
/>
</div>
{children}
</React.Fragment>)
}